// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export enum InstrumentDeliveryType
{
    Delivery_Physical = 0,
    Delivery_Cash = 1
}